import React from 'react'

export default function VisiGiftDiscountOfferHistory() {
  return (
    <div>VisiGiftDiscountOfferHistory</div>
  )
}
